var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m69.731 29.647-5.456-5.457H47.18l-5.456 5.457-17.61 17.61-.044 7.516L39.108 69.81l7.557-.004 17.61-17.609 5.456-5.456V29.647Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.771,
    cy: 36.908,
    r: 5.094,
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgTag;